import { datePickerWithPresetsOptions } from '@shared/ui-kit/pickers/DatePickerRangeWithPresets/configs/optionCofig';

import type { DatePickerWithPresetsOptionsType } from '@shared/ui-kit/pickers/DatePickerRangeWithPresets/configs/optionCofig';
import type { Moment } from 'moment';

export const getSelectedPresent = (startDate: Moment, endDate: Moment): DatePickerWithPresetsOptionsType => {
  return endDate
    ? datePickerWithPresetsOptions.find((option) =>
        option.check(startDate.startOf('day'), endDate?.endOf('day')),
      ) || { label: 'Custom', value: 'custom', check: () => true }
    : { label: 'Custom', value: 'custom', check: () => true };
};
